<template>
  <v-container>
    <v-row justify="center">
      <v-col md="12">
        <v-card class="pa-4 mb-8">
          <v-card-title>ลงทะเบียนผู้ใช้งาน</v-card-title>
          <v-card-text> </v-card-text>
          <v-form>
            <v-row>
              <!-- <v-col class="mt-5" md="2">
                <v-text-field
                  v-model="firstname"
                  :counter="50"
                  :rules="nameRules"
                  label="คำนำหน้า"
                  required
                ></v-text-field>
              </v-col> -->
              <v-col class="mt-5" md="6">
                <v-text-field
                  variant="outlined"
                  v-model="formData.displayName"
                  :counter="50"
                  :rules="nameRules"
                  label="ชื่อ-นามสกุล"
                  required
                  color="primary"
                ></v-text-field>
              </v-col>
              <v-col class="mt-5" md="2">
                <v-text-field
                  variant="outlined"
                  v-model="formData.studentNumber"
                  :counter="13"
                  :rules="numRule"
                  label="รหัสนักศึกษา"
                  required
                  color="primary"
                  lenght="13"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col class="mt-5" md="4">
                <v-text-field
                  variant="outlined"
                  v-model="authStore.firebaseUser.email"
                  label="อีเมลล์"
                  required
                  color="primary"
                  readonly
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row justify-center>
              <v-col md="6" class="text-right">
                <v-btn @click="registerUser" color="primary">Register</v-btn>
              </v-col>
              <v-col md="6" class="text-left">
                <v-btn @click="handleLogout()" color="red">ยกเลิก</v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue"; // No direct onMounted needed due to `watch` with `immediate: true`
import { useAuthStore } from "@/stores/auth";
const { proxy } = getCurrentInstance();
import { getCurrentInstance } from "vue";
const authStore = useAuthStore();
const validform = ref(0);
const nameRules = [
  (value) => {
    if (value) return true;
    validform.value = 1;
    return "กรุณากรอกชื่อ.";
  },
  (value) => {
    const thaiNameRegex = /^[\u0E00-\u0E7F\s]{1,50}$/;
    if (thaiNameRegex.test(value)) return true;
    validform.value = 1;
    return "กรุณากรอกชื่อให้ถูกต้อง (ตัวอักษรไทยเท่านั้น)";
  },
];

const numRule = [
  (value) => {
    if (value) return true;
    return "กรุณากรอกรหัสนักศึกษา.";
  },
  (value) => {
    const numPattern = /^\d{1,13}$/;
    if (numPattern.test(value)) return true;
    return "กรุณากรอกรหัสนักศึกษาให้ถูกต้อง (ตัวเลข 13 ตัว)";
  },
];

const formData = ref({
  displayName: "",
  studentNumber: "",
  email: "",
});

const handleLogout = async () => {
  const result = await proxy.$swal({
    title: "Are you sure?",
    text: "You will be logged out of your account.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, log me out!",
    cancelButtonText: "Cancel",
  });

  if (result.isConfirmed) {
    try {
      await authStore.logout();

      await proxy.$swal({
        title: "Logged Out!",
        text: "You have been successfully logged out.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      // router.push({ name: "home" });
    } catch (error) {
      proxy.$swal({
        title: "Error!",
        text: "Something went wrong during logout.",
        icon: "error",
      });
    }
  }
};
</script>
